import {MouseEvent, useState} from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Text} from "@pg-design/text-module";
import {NAVIGATION_TEST_IDS} from "@pg-mono/test-ids";

import {useGetClientInfoQuery} from "../../client/api/get_client_info";
import {useGetRegionDetailListQuery} from "../../region/api/get_region_detail_list";
import {getFavouritesEmptyListingUrl} from "../utils/get_favourites_empty_listing_url";

export const FavouritesTopbarEmptyState = () => {
    const {data: survey} = useGetClientInfoQuery();
    const regionIds = survey?.regions ?? [];
    const {data: regions} = useGetRegionDetailListQuery({regionIds}, {skip: regionIds.length === 0});
    const listingUrl = getFavouritesEmptyListingUrl(survey, regions);
    const [isCtaLoading, setIsCtaLoading] = useState(false);

    const onCtaClick = (event: MouseEvent<HTMLElement>) => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) {
            return;
        }

        setIsCtaLoading(true);
    };

    return (
        <div className={emptyStateStyle}>
            <Text align="center" as="p" mb={1} variant="headline_7">
                Nie masz jeszcze ulubionych
            </Text>
            <Text align="center" as="p" color="var(--colors-gray-800)" mb={3} variant="body_copy_2">
                Kliknij serce przy ofercie, a zapiszemy ją tutaj. Łatwo do niej wrócisz.
            </Text>
            <Button
                as="a"
                dataTestId={NAVIGATION_TEST_IDS.FAVOURITES.EMPTY_SEARCH}
                fullWidth
                href={listingUrl}
                isLoading={isCtaLoading}
                onClick={onCtaClick}
                size="medium"
                textVariant="button_big"
                variant="outlined_secondary"
            >
                Szukaj mieszkań
            </Button>
        </div>
    );
};

const emptyStateStyle = css({
    mt: 4
});
import {MouseEvent, useState} from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Text} from "@pg-design/text-module";
import {NAVIGATION_TEST_IDS} from "@pg-mono/test-ids";

import {useGetClientInfoQuery} from "../../client/api/get_client_info";
import {useGetRegionDetailListQuery} from "../../region/api/get_region_detail_list";
import {getFavouritesEmptyListingUrl} from "../utils/get_favourites_empty_listing_url";

export const FavouritesTopbarEmptyState = () => {
    const {data: survey} = useGetClientInfoQuery();
    const regionIds = survey?.regions ?? [];
    const {data: regions} = useGetRegionDetailListQuery({regionIds}, {skip: regionIds.length === 0});
    const listingUrl = getFavouritesEmptyListingUrl(survey, regions);
    const [isCtaLoading, setIsCtaLoading] = useState(false);

    const onCtaClick = (event: MouseEvent<HTMLElement>) => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) {
            return;
        }

        setIsCtaLoading(true);
    };

    return (
        <div className={emptyStateStyle}>
            <Text align="center" as="p" mb={1} variant="headline_7">
                Nie masz jeszcze ulubionych
            </Text>
            <Text align="center" as="p" color="var(--colors-gray-800)" mb={3} variant="body_copy_2">
                Kliknij serce przy ofercie, a zapiszemy ją tutaj. Łatwo do niej wrócisz.
            </Text>
            <Button
                as="a"
                dataTestId={NAVIGATION_TEST_IDS.FAVOURITES.EMPTY_SEARCH}
                fullWidth
                href={listingUrl}
                isLoading={isCtaLoading}
                onClick={onCtaClick}
                size="medium"
                textVariant="button_big"
                variant="outlined_secondary"
            >
                Szukaj mieszkań
            </Button>
        </div>
    );
};

const emptyStateStyle = css({
    mt: 4
});
